import React, { useEffect, useState } from "react";
import "./styles.css";
import Cookies from "js-cookie";
export default function CalorieCalculator() {

    const [form, setForm] = useState({
        weight: "",
        height: "",
        age: "",
        sex: "male",
        activity: 1.2,
        goal: "maintain"
    });

    const [savedInfo, setSavedInfo] = useState(null);
    const [result, setResult] = useState(null);

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    };

    useEffect(() => {
        const calories = Cookies.get("userCalories");
        const weight = Cookies.get("userWeight");
        const goal = Cookies.get("userGoal");
        const protein = Cookies.get("userProtein");
        const carbs = Cookies.get("userCarbs");
        const fats = Cookies.get("userFats");

        if (calories && weight && goal) {
            setSavedInfo({
                calories,
                weight,
                goal,
                protein,
                carbs,
                fats
            });
        }
    }, []);

    const calculate = () => {

        const weight = parseFloat(form.weight);
        const height = parseFloat(form.height);
        const age = parseFloat(form.age);

        let bmr;

        if (form.sex === "male") {
            bmr = 10 * weight + 6.25 * height - 5 * age + 5;
        } else {
            bmr = 10 * weight + 6.25 * height - 5 * age - 161;
        }

        let calories = bmr * form.activity;

        if (form.goal === "loss") calories -= 500;
        if (form.goal === "muscle") calories += 300;
        if (form.goal === "recomp") calories -= 200;

        let protein;

        if (form.goal === "recomp") protein = weight * 2.2;
        else if (form.goal === "muscle") protein = weight * 2;
        else protein = weight * 1.8;

        const fats = (calories * 0.25) / 9;
        const carbs = (calories - (protein * 4 + fats * 9)) / 4;

        setResult({
            calories: Math.round(calories),
            protein: Math.round(protein),
            carbs: Math.round(carbs),
            fats: Math.round(fats)
        });

        Cookies.set("userCalories", Math.round(calories));
        Cookies.set("userWeight", form.weight);
        Cookies.set("userGoal", form.goal);
        Cookies.set("userProtein", Math.round(protein));
        Cookies.set("userCarbs", Math.round(carbs));
        Cookies.set("userFats", Math.round(fats));
    };

    return (
        <div className="container">
            {savedInfo && (
                <div className="saved-box">
                    Your calories for the goal <b>{savedInfo.goal}</b> for the weight{" "}
                    <b>{savedInfo.weight} kg</b> is:
                    <br />
                    <b>{savedInfo.calories} kcal</b>
                    <br />
                    <b> {savedInfo.protein} g of protein</b>
                    <br />
                    <b> {savedInfo.carbs} g of carbs</b>
                    <br />
                    <b> {savedInfo.fats} g of fats.</b>
                    <br />
                    <br />
                </div>
            )}
            <div className="card">

                <h1>Fitness Calories Calculator</h1>

                <div className="form-group">
                    <label>Weight (kg)</label>
                    <input name="weight" onChange={handleChange} />
                </div>

                <div className="form-group">
                    <label>Height (cm)</label>
                    <input name="height" onChange={handleChange} />
                </div>

                <div className="form-group">
                    <label>Age</label>
                    <input name="age" onChange={handleChange} />
                </div>

                <div className="form-group">
                    <label>Sex</label>
                    <select name="sex" onChange={handleChange}>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                    </select>
                </div>

                <div className="form-group">
                    <label>Activity Level</label>
                    <select name="activity" onChange={handleChange}>
                        <option value="1.2">Sedentary</option>
                        <option value="1.375">Light Activity</option>
                        <option value="1.55">Moderate Activity</option>
                        <option value="1.725">Very Active</option>
                    </select>
                </div>

                <div className="form-group">
                    <label>Goal</label>
                    <select name="goal" onChange={handleChange}>
                        <option value="maintain">Maintain Weight</option>
                        <option value="loss">Lose Weight</option>
                        <option value="muscle">Gain Muscle</option>
                        <option value="recomp">Lose Fat & Gain Muscle</option>
                    </select>
                </div>

                <button className="calculate-btn" onClick={calculate}>
                    Calculate
                </button>

                {result && (
                    <div className="results">
                        <h2>Your Daily Nutrition</h2>

                        <div className="result-item">
                            Calories: <span>{result.calories} kcal</span>
                        </div>

                        <div className="result-item">
                            Protein: <span>{result.protein} g</span>
                        </div>

                        <div className="result-item">
                            Carbs: <span>{result.carbs} g</span>
                        </div>

                        <div className="result-item">
                            Fats: <span>{result.fats} g</span>
                        </div>

                    </div>
                )}

            </div>

        </div>
    );
}